// extracted by mini-css-extract-plugin
export var header = "_w0-1";
export var maskBottom = "_w0-6";
export var maskMiddle = "_w0-7";
export var maskTop = "_w0-5";
export var root = "_w0-0";
export var scrollDownButton = "_w0-3";
export var scrollDownButtonHidden = "_w0-4";
export var viewport = "_w0-2";